import { createAd as createAdThunk, updateAd as updateAdThunk, deleteAd as deleteAdThunk } from '../reducers/adsSlice';

// Action to create ad
export const createAd = (adminData, payload) => {
  return async (dispatch) => {
    try {
      await dispatch(createAdThunk({ adminData, payload }));
    } catch (error) {
      console.error('Error creating ad:', error);
    }
  };
};

// Action to update ad
export const updateAd = (adminData, payload) => {
  return async (dispatch) => {
    try {
      await dispatch(updateAdThunk({ adminData, payload }));
    } catch (error) {
      console.error('Error updating ad:', error);
    }
  };
};

// Action to delete ad
export const deleteAd = (adminData, adId) => {
  return async (dispatch) => {
    try {
      await dispatch(deleteAdThunk({ adminData, adId }));
    } catch (error) {
      console.error('Error deleting ad:', error);
    }
  };
};